import { useMemo, useState, useRef, useContext } from "react"
import { UserContext } from "../../store/store"

import { limits } from "../../services/statics"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { kebabify } from "../../helpers/utils"

import { useQuery } from "../../hooks/useQuery"
import { ModalError } from "../../components/ui/modal/ModalError"
import { ModalOk } from "../../components/ui/modal/ModalOk"
import { msg } from "../../components/ui/modal/utils"
import { Paginator } from "../../components/ui/Paginator"

import { ModalEliminarWrd } from "../../components/admin/ModalEliminarWrd"
import { ModalEliminarBatchWrd } from "../../components/admin/ModalEliminarBatchWrd"
import { ModalEditarWrd } from "../../components/admin/ModalEditarWrd"
import { config } from "../../config"
import { Trans, useTranslation } from "react-i18next"
import { t } from "i18next"

const AgregarWordsForm = () => {
  // elements
  const form = useRef()

  // estado
  const [definicion, setDefinicion] = useState(""),
    [definiendum, setDefiniendum] = useState(""),
    [selectedTags, setSelectedTags] = useState([])

  // pal msg de ok
  const [cache, setCache] = useState("")

  const createWord = useQuery(),
    showRes = useState(false)

  const cleanForm = () => {
    form.current.reset()
    setCache(definiendum)
    setDefinicion("")
    setDefiniendum("")
    setSelectedTags([])
  }

  const { t } = useTranslation()

  // tags
  const { url, opt } = useMemo(() => api.tags.readAll({}), []),
    [tags, isPending, err] = useFetch({ url, opt }),
    SelectTags = () => {
      const handleClick = (tag) => {
        setSelectedTags((currents) =>
          currents.includes(tag.name)
            ? currents.filter((t) => t !== tag.name)
            : currents.concat(tag.name)
        )
      }

      if (isPending && !err) return <span>{t(`ui.btns.loading`)}...</span>

      return (
        <div className="d-flex flex-wrap">
          {tags.entries.map((tag, tix) => (
            <div key={tix} className="px-2">
              <input
                onChange={() => handleClick(tag)}
                checked={selectedTags.includes(tag.name)}
                type="checkbox"
              />
              &nbsp;
              {tag.name}
            </div>
          ))}
        </div>
      )
    }

  const onSubmitForm = async (e) => {
    e.preventDefault()
    showRes[1](true)

    const { url, opt } = api.wrds.create({
      token: getCookie("jwt"),
      words: [
        {
          definicion,
          definiendum,
          tags: selectedTags,
        },
      ],
    })

    createWord.url.current = url
    createWord.opt.current = opt
    createWord.run({
      onOk: cleanForm,
    })
  }

  return (
    <>
      {createWord.res && !createWord.err && (
        <ModalOk
          show={showRes}
          body={msg(
            <Trans
              i18nKey="admin.words.word_succesfully_added"
              values={{ word: cache }}
              components={{ i: <i /> }}
            />
            // <>La palabra <i>{cache}</i> ha sido agregada con éxito.</>
          )}
        />
      )}

      {createWord.res && createWord.err && (
        <ModalError id="err-res" show={showRes} res={createWord.res} />
      )}

      <div className="col-9" style={{ margin: "0 auto" }}>
        <form ref={form}>
          <fieldset>
            <legend>{t(`admin.words.new_word`)}</legend>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.words.definiendum`)}
              </label>
              <input
                onChange={(e) => setDefiniendum(e.target.value)}
                className="form-control"
                placeholder={t(`admin.words.placeholder_definiendum`)}
              />
            </div>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.words.definition`)}
              </label>
              <textarea
                onChange={(e) => setDefinicion(e.target.value)}
                placeholder={t(`admin.words.placeholder_definition`)}
                className="form-control"></textarea>
            </div>

            <div className="form-group">
              <label className="form-label mt-4">{t(`admin.words.tags`)}</label>
              <br />
              <SelectTags />
            </div>

            <button
              onClick={onSubmitForm.bind(this)}
              disabled={createWord.isPending}
              type="submit"
              className="btn btn-primary mt-5">
              {createWord.isPending
                ? t(`ui.btns.submiting`) + "..."
                : t(`ui.btns.create`)}
            </button>
          </fieldset>
        </form>
      </div>
    </>
  )
}

function csvToArray(text) {
  let p = "",
    row = [""],
    ret = [row],
    i = 0,
    r = 0,
    s = !0,
    l
  for (l of text) {
    if ('"' === l) {
      if (s && l === p) row[i] += l
      s = !s
    } else if ("," === l && s) l = row[++i] = ""
    else if ("\n" === l && s) {
      if ("\r" === p) row[i] = row[i].slice(0, -1)
      row = ret[++r] = [(l = "")]
      i = 0
    } else row[i] += l
    p = l
  }
  return ret
}

//var csv is the CSV file with headers
function csvJSON(text) {
  // elimino los doble espacios
  text = text.replace(/\n\s*\n/g, "\n").trim()

  let csv = csvToArray(text)

  // omito el header y parseo la tercera columna (la de los tags)
  csv = csv.slice(1).map((row, i) => {
    row[2] = row[2].split(",").map((s) => s.trim().replace(/[^a-z0-9\s]/gi, ""))

    return {
      definiendum: row[0],
      definicion: row[1],
      tags: row[2],
    }
  })

  return csv // JavaScript object
}

const SubirArchivoForm = () => {
  // elements
  const form = useRef(),
    fileInput = useRef()

  // state
  const [words, setWords] = useState(null)

  // query
  const uploadWords = useQuery(),
    showRes = useState(false)

  const onChangeFile = (event) => {
    let reader = new FileReader()
    reader.readAsText(event.target.files[0])

    reader.onload = (event) => {
      const ext = fileInput.current.files[0].type

      const obj =
        ext === "application/json"
          ? JSON.parse(event.target.result)
          : csvJSON(event.target.result)

      setWords(obj)
    }
  }

  const cleanForm = () => {
    form.current.reset()
    setWords(null)
  }

  const onSubmitForm = async (e) => {
    e.preventDefault()

    showRes[1](true)

    const { url, opt } = api.wrds.create({
      token: getCookie("jwt"),
      words,
    })

    uploadWords.url.current = url
    uploadWords.opt.current = opt
    uploadWords.run({
      onOk: cleanForm,
    })
  }

  const { t } = useTranslation()

  // eg.
  // for `resource` "sample/ejemplo-palabras.json", it returns
  // "http://localhost:3000/sample/ejemplo-palabras.json"
  // or "https://www.fing.edu.uy/inco/proyectos/cinacina/sample/ejemplo-palabras.json"
  // respectively
  const resource_url = (resource) => {
    return window.location.href
      .replace(window.location.hash, "")
      .replace("/admin", resource)
  }

  return (
    <>
      {uploadWords.res && !uploadWords.err && (
        <ModalOk
          show={showRes}
          body={msg(
            t(`admin.words.words_in_file_succesfully_added`)
            // <>Las palabras contenidas en el archivo han sido agregadas con éxito.</>
          )}
        />
      )}

      {uploadWords.res && uploadWords.err && (
        <ModalError id="err-res" show={showRes} res={uploadWords.res} />
      )}

      <div className="col-9" style={{ margin: "0 auto" }}>
        <form ref={form}>
          <fieldset>
            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.words.select_json_or_csv`)}
              </label>

              <input
                accept=".json,.csv"
                disabled={uploadWords.isPending}
                className="form-control"
                ref={fileInput}
                onChange={onChangeFile.bind(this)}
                type="file"
              />

              <div className="row my-5">
                <p>
                  <small>
                    <Trans
                      i18nKey="admin.words.example"
                      components={{
                        link1: (
                          // eslint-disable-next-line
                          <a
                            href={resource_url("/sample/ejemplo-palabras.csv")}
                          />
                        ),
                        link2: (
                          // eslint-disable-next-line
                          <a
                            href={resource_url("/sample/ejemplo-palabras.json")}
                          />
                        ),
                      }}
                    />
                  </small>
                </p>
              </div>
            </div>

            <button
              onClick={onSubmitForm.bind(this)}
              disabled={uploadWords.isPending}
              type="submit"
              className="btn btn-primary">
              {uploadWords.isPending
                ? t(`ui.btns.uploading_wait`)
                : t(`ui.btns.upload`)}
            </button>
          </fieldset>
        </form>
      </div>
    </>
  )
}

export const AgregarWords = () => {
  const { t } = useTranslation()

  const [tab, setTab] = useState(kebabify(t(`admin.words.from_form`)))

  const handleClick = (e) => {
    e.preventDefault()
    const id = kebabify(e.target.innerHTML)
    setTab(id)
  }

  const tabs = [t(`admin.words.from_form`), t(`admin.words.upload_file`)]

  const on = (x) => tab === kebabify(t(x))

  const colStyle = { margin: "0 auto" }

  const ulStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  }

  return (
    <div className="col-lg-8 col-12" style={colStyle}>
      <ul className="nav nav-tabs mb-4" style={ulStyle}>
        {tabs.map((t, ix) => (
          <li key={ix} className="nav-item">
            <a
              className={"nav-link" + (kebabify(t) === tab ? " active" : "")}
              href="/#"
              onClick={handleClick.bind(this)}>
              {t}
            </a>
          </li>
        ))}
      </ul>

      {on(`admin.words.from_form`) && <AgregarWordsForm />}
      {on(`admin.words.upload_file`) && <SubirArchivoForm />}
    </div>
  )
}

const ListWords = ({
  words,
  onClickEditar,
  onClickEliminar,
  batchDelete,
  toggleSelect,
}) => {
  const [state] = useContext(UserContext)
  const theme = state.theme === "light" ? "table-striped" : "table-dark"

  return (
    <table className={"table table-hover w-100 " + theme}>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>ID</th>
          <th>{t(`admin.words.definiendum`)}</th>
          <th>{t(`admin.words.definition`)}</th>
          <th>{t(`admin.words.tags`)}</th>
          <th>
            <center>{t(`ui.tables.edit`)}</center>
          </th>
          <th>
            <center>{t(`ui.tables.delete`)}</center>
          </th>
        </tr>
      </thead>
      <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
        {words.map((word, ix) => (
          <tr key={ix}>
            <td>
              <input
                type="checkbox"
                checked={batchDelete.includes(word.id)}
                onChange={() => toggleSelect(word.id)}
              />
            </td>
            <td>{word.id}</td>
            <td>{word.definiendum}</td>
            <td>
              <i>{word.definicion}</i>
            </td>
            <td>{word.tags.map((t) => t.name).join(", ")}</td>
            <td>
              <center>
                <button
                  type="button"
                  onClick={onClickEditar.bind(this, word)}
                  className="btn btn-sm tooltip edit-tooltip">
                  ✏️
                </button>
              </center>
            </td>
            <td>
              <center>
                <button
                  type="button"
                  onClick={onClickEliminar.bind(this, word)}
                  className="btn btn-sm tooltip elim-tooltip">
                  ❌
                </button>
              </center>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export const GestionarWords = () => {
  // state
  const [limit, setLimit] = useState(config.default_limit),
    [offest, setOffset] = useState(1),
    [matching, setMatching] = useState(""),
    [tag, setTag] = useState(null)

  // tags
  const getTags = useMemo(() => api.tags.readAll({}), [])
  const [tags, tags_pending, tags_err] = useFetch({
    url: getTags.url,
    opt: getTags.opt,
  })

  // edit/delete word

  const [selected, setSelected] = useState(null),
    modalEliminar = useState(false),
    modalBatchEliminar = useState(false),
    modalEditar = useState(false)

  const onClickEditar = (entry, e) => {
    e.preventDefault()
    modalEditar[1](true)
    setSelected(entry)
  }

  const onClickEliminar = (entry, e) => {
    e.preventDefault()
    setSelected(entry)
    modalEliminar[1](true)
  }

  const onClickBatchEliminar = (e) => {
    e.preventDefault()
    modalBatchEliminar[1](true)
  }

  const { url, opt } = useMemo(
    () =>
      api.wrds.readAll({
        from: offest,
        limit,
        match: matching,
        tag,
      }),
    [limit, offest, matching, tag]
  )
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const [batchDelete, setBatchDelete] = useState([])
  const toggleSelect = (id) => {
    if (batchDelete.includes(id))
      setBatchDelete(batchDelete.filter((x) => x !== id))
    else setBatchDelete([...batchDelete, id])
  }

  return (
    <>
      {modalEditar[0] && (
        <ModalEditarWrd
          show={modalEditar}
          entry={selected}
          setEntries={setData}
        />
      )}

      {modalEliminar[0] && (
        <ModalEliminarWrd
          show={modalEliminar}
          entry={selected}
          setEntries={setData}
        />
      )}

      {modalBatchEliminar[0] && (
        <ModalEliminarBatchWrd
          show={modalBatchEliminar}
          ids={batchDelete}
          setEntries={setData}
          setBatchDelete={setBatchDelete}
        />
      )}

      <div className="col-12" style={{ margin: "0 auto" }}>
        <h4>{t(`admin.words.manage_words`)}</h4>

        <div className="d-flex justify-content-end align-items-center flex-row pb-3">
          <div style={{ flexGrow: 1 }}>
            <button
              type="button"
              disabled={batchDelete.length === 0}
              className="btn btn-danger btn-sm"
              onClick={onClickBatchEliminar.bind(this)}>
              {t(`ui.btns.batch_delete`, { n: batchDelete.length })}
            </button>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              {t(`ui.tables.limit`)}
              <select
                className="form-select mini-select mx-2"
                value={limit}
                onChange={(e) => setLimit(parseInt(e.target.value))}
                style={{ fontSize: "14px" }}>
                {limits.map((lim, ix) => (
                  <option key={ix} value={lim}>
                    {lim}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              {t(`admin.words.tag`)}
              {!tags_pending && !tags_err && (
                <select
                  className="form-select mini-select mx-2"
                  value={tag}
                  onChange={(e) => {
                    setOffset(1) // fix paginacion
                    setTag(parseInt(e.target.value))
                  }}
                  style={{ fontSize: "14px" }}>
                  <option value="" disabled selected>
                    Any
                  </option>
                  {tags.entries.map((tag, ix) => (
                    <option key={ix} value={tag.id}>
                      {tag.name}
                    </option>
                  ))}
                </select>
              )}
            </label>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              <input
                className="form-control form-control-sm"
                style={{ width: "10vw" }}
                type="text"
                onChange={(e) => {
                  setOffset(1) // fix paginacion
                  setMatching(e.target.value)
                }}
                placeholder={t(`admin.words.placeholder_filter`)}
              />
            </label>
          </div>
        </div>
        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && (
          <ListWords
            words={data.entries}
            onClickEditar={onClickEditar}
            onClickEliminar={onClickEliminar}
            batchDelete={batchDelete}
            toggleSelect={toggleSelect}
          />
        )}

        {!isPending && !err && (
          <Paginator
            total={data.total}
            offset={offest}
            radius={9}
            setOffset={setOffset}
            pageSize={limit}
          />
        )}
      </div>
    </>
  )
}
